import type { AuthClient, Credentials } from './AuthClient';

export enum DeliveryMethod {
  Email = 'email',
  SMS = 'sms',
}

export interface PasswordlessAuthClient<T = unknown> extends AuthClient<T> {
  /**
   * Initiates the passwordless process
   *
   * @param mode - Where you want your code delivered
   * @param username - The username that corresponds to the mode of delivery
   */
  startAuthentication(
    mode: DeliveryMethod,
    username: string,
  ): Promise<AuthenticationDetails>;
  /**
   * Completes the passwordless process by exchanging the code for auth
   * Credentials
   *
   * @param mode - The mode used to initiate the process
   * @param username - The username where the code was delivered
   * @param code - The OTP that was delivered
   */
  completeAuthentication(
    mode: DeliveryMethod,
    username: string,
    code: string,
  ): Promise<Credentials>;
}

export interface AuthenticationDetails {
  username: string;
  field: string;
}
